import React, { useState } from 'react';

import { Box, Sheet, Text } from '@betterment/samba-react';
import { toTitleCase } from '@betterment/shared-components/src/utils/StringHelpers';

import { EnvelopeAccountPendingOrdersQuery } from './graphql/envelopeAccountPendingOrders.generated';

import { Drawer } from '../../../activity/components/drawer/Drawer';

type PendingOrder = NonNullable<
  Extract<EnvelopeAccountPendingOrdersQuery['account'], { __typename: 'DirectTradingAccount' }>['pendingOrders'][number]
>;

interface PendingOrderTagProps {
  item: PendingOrder;
}

export const PendingOrderTag: React.FC<PendingOrderTagProps> = ({ item }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { security, tradeSide } = item;
  const { symbol } = security;
  const action = toTitleCase(tradeSide);

  return (
    <Sheet overlay="weak" open={isOpen} onOpenChange={setIsOpen}>
      <Sheet.Trigger asChild={true}>
        <Box
          css={{
            backgroundColor: 'background.neutral',
            borderRadius: 'round',
            display: 'flex',
            alignItems: 'center',
            paddingX: 'space.200',
            paddingY: 'space.25',
            height: '28px',
            cursor: 'pointer',
          }}
        >
          <Text css={{ fontSize: '14px', lineHeight: '21px' }}>
            {symbol} {action}
          </Text>
        </Box>
      </Sheet.Trigger>

      <Sheet.Content
        css={{ overflowY: 'auto', gap: 'space.300', zIndex: '300' }}
        onOpenAutoFocus={e => e.preventDefault()}
      >
        <Drawer item={item} />
      </Sheet.Content>
    </Sheet>
  );
};
